<p>
  <strong>Which roles are allowed to comment?</strong>
</p>
<mg-multi-select-role
  [roles]="availableCommentRoles$ | async"
  [selectedRoles]="commentingRoles"
  (roleSelect)="onRoleSelect($event)"
  (roleDeselect)="onRoleDeselect($event)">
</mg-multi-select-role>
